import React, { useState } from "react";
import { FaXTwitter } from "react-icons/fa6";
import { CiLinkedin } from "react-icons/ci";
import { FiInstagram } from "react-icons/fi";
import support from "../../Assets/support.svg";
import map from "../../Assets/map-icon.svg";
import ButtonMailto from "../../Components/MailToButton/ButtonMailTo";
import { CiFacebook } from "react-icons/ci";
import { Link } from "react-router-dom";
import { Button } from "../Button/Button";
import Select from "react-select";
import emailjs from "@emailjs/browser";
import { countries } from "countries-list";
import "./style.css";

export const ContactSection = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [message, setMessage] = useState({
    type: "",
    message: "",
    header: "",
  });

  const countryOptions = Object.keys(countries).map((countryCode) => ({
    value: countryCode,
    label: countries[countryCode].name,
  }));

  const contactForm = (e) => {
    setMessage({
      type: "",
      message: "",
      header: "",
    });

    e.preventDefault();
    const data = new FormData(e.target);
    const email = Object.fromEntries(data.entries()).email;
    const fname = Object.fromEntries(data.entries()).fname;
    const lname = Object.fromEntries(data.entries()).lname;
    const message = Object.fromEntries(data.entries()).message;
    const phone = Object.fromEntries(data.entries()).phone;
    const agree = Object.fromEntries(data.entries()).checkbox_agree;
    console.log(agree);
    if (
      email !== "" &&
      fname !== "" &&
      lname !== "" &&
      message !== "" &&
      phone !== "" &&
      selectedOption !== null &&
      agree !== undefined
    ) {
      var templateParams = {
        fname,
        lname,
        email,
        message,
        phone,
        country: selectedOption.label,
      };

      emailjs
        .send(
          "service_nh6wz9i",
          "template_ji54jxd",
          templateParams,
          "arT_IJjFflOQ3Q45t"
        )
        .then(
          function (response) {
            setMessage({
              type: "success",
              message:
                "Message sent successfully, Our Support team will get back to you shortly.",
              header: "Message Sent!",
            });
            e.target.reset(); // This will reset the form fields
          },
          function (error) {
            setMessage({
              type: "error",
              message:
                "Please contact the DataDept directly via email. We are facing some issues with the form.",
              header: "Something went wrong!",
            });
          }
        );
    } else {
      setMessage({
        type: "error",
        message: "Please make sure to fill the data before submitting.",
        header: "Missing Field!",
      });
    }
  };

  return (
    <section className="contact-us container-style">
      <div className="content-sizing contact-us-wrapper">
        <div className="left-child-contact">
          <div className="header-contact-form">
            <span className="small-tag">CONTACT</span>
            <h2>Let's get in touch</h2>
            <p>
              You can reach us anytime via{" "}
              <ButtonMailto label="datadept.ca@gmail.com" />
            </p>
          </div>

          {message && message.type === "success" && (
            <div className="message-box success-box">
              <i className="bi bi-check2-circle"></i>
              <div className="message-info">
                <h3>{message.header}</h3>
                <p>{message.message}</p>
              </div>
            </div>
          )}

          {message && message.type === "error" && (
            <div className="message-box error-box">
              <i class="bi bi-x-octagon"></i>
              <div className="message-info">
                <h3>{message.header}</h3>
                <p>{message.message}</p>
              </div>
            </div>
          )}

          <form className="contact-form-main" onSubmit={contactForm}>
            <div className="col-2-container">
              <div className="col-1-input">
                <label htmlFor="firstname">First Name *</label>
                <input
                  id="firstname"
                  placeholder="First Name"
                  type="text"
                  name="fname"
                />
              </div>
              <div className="col-1-input">
                <label htmlFor="last">Last Name *</label>
                <input
                  id="last"
                  placeholder="Last Name"
                  type="text"
                  name="lname"
                />
              </div>
            </div>

            <div className="col-1-input">
              <label htmlFor="email">Email *</label>
              <input
                id="email"
                placeholder="Your Email"
                type="email"
                name="email"
              />
            </div>

            <div className="col-2-container">
              <div className="col-1-input">
                <label htmlFor="phone">Phone Number *</label>
                <input
                  id="phone"
                  placeholder="Your Number"
                  type="phone"
                  name="phone"
                />
              </div>

              <div className="col-1-input">
                <label htmlFor="react-select-5-input">Country *</label>
                <Select
                  value={selectedOption}
                  onChange={setSelectedOption}
                  options={countryOptions}
                />
              </div>
            </div>

            <div className="col-1-input">
              <label htmlFor="message">
                What services are you interested in? *
              </label>
              <textarea
                id="message"
                placeholder="Leave us a message..."
                name="message"
              />
            </div>

            <div class="checkboxes__item">
              <label class="checkbox style-c">
                <input type="checkbox" name="checkbox_agree" />
                <div class="checkbox__checkmark"></div>
                <div class="checkbox__body">
                  You agree to our{" "}
                  <Link to="/term-and-condition">terms and conditions.</Link>
                </div>
              </label>
            </div>

            <Button>Get Started</Button>
          </form>
        </div>

        {/* <ul className='number-count'>
              <li>
                <h3>10+ <h4>Years</h4></h3>
                <p>Field Experience</p>
              </li>
              <li>
                <h3>100+ <h4>Projects</h4></h3>
                <p>Done Around World</p>
              </li>
              <li>
                <h3>99%</h3>
                <p>Client Satisfaction</p>
              </li>
              <li>
                <h3>2 <h4>Min</h4></h3>
                <p>Response Time</p>
              </li>
            </ul> */}

        <ul className="right-child-contact">
          <li>
            <img src={support} alt="Support Icon" loading="lazy" />
            <h3>Contact Info</h3>
            <ul>
              <li>+1 204-333-4080</li>
              <li>
                <ButtonMailto label="datadept.ca@gmail.com" />
              </li>
            </ul>
          </li>
          <li>
            <img src={map} alt="Map Icon" loading="lazy" />
            <h3>Our Office</h3>
            <p>
              We are a Winnipeg, Manitoba-based cloud company that serves
              customers all over the World.
            </p>
          </li>
          <li>
            <ul className="social-footer-icons">
              {/* <li>
                <a
                  href="https://twitter.com/DataDeptX"
                  target="_blank"
                  aria-label="Visit Our Twitter"
                >
                  <FaXTwitter /> Twitter
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/DataDept/about/"
                  target="_blank"
                  aria-label="Visit Our Linkedin"
                >
                  <CiLinkedin /> LinkedIn
                </a>
              </li> */}
              <li>
                <a
                  href="https://www.instagram.com/datadept.ca?igsh=MTI2cWI0ZzVqbGtkeA%3D%3D&utm_source=qr"
                  target="_blank"
                  aria-label="Visit Our Instagram"
                >
                  <FiInstagram /> Instagram
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </section>
  );
};
